import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import { DefaultCoursesWrapper,
    Header,
    FilterDropdownWrapper,
    DefaultCoursesContainer,
    YearDropDownWrapper,
    DataColumn,
    DataRow,
    FooterWrapper,
    LoaderWrapper,
    DropdownWrapper } from './styled';
import DropdownList from '../../components/dropdown-list';
import messages from './messages';
import Button from '../button/index';
import Loader from '../pulse-loader';
import { MATHLETICS_PRODUCT_ID } from '../../constants';

export const generateYearRow = years => years.map(year => <DataRow key={`_${year.value}`}>{year.value}</DataRow>);

const setupDropdownData = ({ intl, courses, onDefaultCourseChange, defaultCourses, selectedProductId, defaultCountry, selectedState, year }) => {
    let defaultValue = defaultCourses[Number(year.id)];
    let courseList;

    if (parseInt(selectedProductId, 10) !== MATHLETICS_PRODUCT_ID && defaultCountry === 'AUS' && selectedState === '') {
        courseList = [...courses];
    } else {
        courseList = [
            {
                courseName: intl.formatMessage(messages.noCourse),
                id: 0
            },
            ...courses
        ];
        if (!defaultValue) {
            defaultValue = { name: intl.formatMessage(messages.noCourse) };
        }
    }

    return (<DataRow key={`_${year.value}`}>
        <DropdownList
            onChange={(name, courseName) => {
                const id = courseList.filter(course => course.courseName === courseName)[0].id;
                onDefaultCourseChange(year, courseName, id);
            }}
            optionKey="courseName"
            options={courseList}
            optionText="courseName"
            value={defaultValue && defaultValue.name} />
    </DataRow>);
};

const DefaultCourses = (props) => {
    if (!props.countries.isLoaded) {
        return (
            <LoaderWrapper>
                <Loader size="5px" />
            </LoaderWrapper>
        );
    }

    return (<DefaultCoursesWrapper>
        <DefaultCoursesContainer>
            <Header>
                <FilterDropdownWrapper>
                    <span data-testid="product">{props.intl.formatMessage(messages.product)}:</span>
                    <DropdownWrapper data-testid="product-filter">
                        <DropdownList
                            name="selectProduct"
                            onChange={props.setProduct}
                            optionKey="id"
                            options={props.products}
                            optionText="name"
                            value={props.selectedProductId} />
                    </DropdownWrapper>
                </FilterDropdownWrapper>
                <FilterDropdownWrapper data-testid="country-wrapper">
                    <span data-testid="country">{props.intl.formatMessage(messages.country)}:</span>
                    <DropdownWrapper data-testid="country-filter">
                        <DropdownList
                            name="selectCountry"
                            onChange={props.setCountry}
                            optionKey="code"
                            options={props.countries.items}
                            optionText="name"
                            value={props.defaultCountry} />
                    </DropdownWrapper>
                </FilterDropdownWrapper>
                <FilterDropdownWrapper data-testid="state-wrapper">
                    <span data-testid="state">{props.intl.formatMessage(messages.state)}:</span>
                    <DropdownWrapper data-testid="state-filter">
                        <DropdownList
                            name="selectState"
                            onChange={props.handleOnStateSelect}
                            optionKey="code"
                            options={props.countries.items.filter(country => country.code === props.defaultCountry)[0].states}
                            optionText="name"
                            placeholder="Select a state"
                            value={props.selectedState} />
                    </DropdownWrapper>
                </FilterDropdownWrapper>
            </Header>
            <YearDropDownWrapper>
                <DataColumn width="150px">
                    <DataRow isHeader>{props.intl.formatMessage(messages.year)}</DataRow>
                    {generateYearRow(props.years)}
                </DataColumn>
                <DataColumn width="600px">
                    <DataRow isHeader>{props.intl.formatMessage(messages.courses)}</DataRow>
                    {
                        props.years.map(year => setupDropdownData({ ...props, year }))
                    }
                </DataColumn>
            </YearDropDownWrapper>
            <FooterWrapper className={'footerWrapper'}>
                <Button
                    className="actionButton"
                    handleOnClick={props.handleBackButton}
                    label={props.intl.formatMessage(messages.back)}
                    primary />
                <Button
                    className="actionButton"
                    disabled={!props.dataSaved || props.isSaved}
                    handleOnClick={props.handleOnSave}
                    label={props.intl.formatMessage(messages.save)}
                    primary />
            </FooterWrapper>
        </DefaultCoursesContainer>
    </DefaultCoursesWrapper>);
};

DefaultCourses.propTypes = {
    intl: intlShape.isRequired,
    countries: PropTypes.oneOfType([
        PropTypes.array.isRequired,
        PropTypes.object.isRequired
    ]),
    years: PropTypes.array.isRequired,
    defaultCountry: PropTypes.string,
    setCountry: PropTypes.func,
    handleOnSave: PropTypes.func,
    dataSaved: PropTypes.bool,
    isSaved: PropTypes.bool,
    handleBackButton: PropTypes.func,
    products: PropTypes.array,
    setProduct: PropTypes.func,
    selectedProductId: PropTypes.string,
    selectedState: PropTypes.string,
    handleOnStateSelect: PropTypes.func
};

DefaultCourses.defaultProps = {
    courses: [],
    defaultCourses: {},
    onDefaultCourseChange: () => {}
};

export default injectIntl(DefaultCourses);



// WEBPACK FOOTER //
// ./app/components/default-courses/index.js